









import { defineComponent, getCurrentInstance } from "@vue/composition-api";
import { useGroups } from "@/hooks/useGroups";
import useHideMainMenu from "@/hooks/useHideMainMenu";
import MassMessageEdit from "@/components/MassMessageEdit";

export default defineComponent({
  name: "PageMassMessage",
  components: { MassMessageEdit },
  props: { ids: { type: Array as () => string[] } },
  setup() {
    useHideMainMenu();

    const { loading: groupLoading, groups, getData } = useGroups({ system: true });
    getData();

    const vm = getCurrentInstance();
    const onSave = () => vm?.$router.back();

    return {
      groups,
      groupLoading,
      onSave,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm: any) => {
      if (!vm.allowMassMessage && vm.isMassMessage) {
        vm.$router.replace(from);
      }
    });
  },
});
